<mat-toolbar class="secondary-toolbar mat-elevation-z1">
  <div *ngIf="state!='LIST'" class="secondary-toolbar-item selectable" (click)="showList()"><mat-icon>list</mat-icon> All Partners</div>
  <ng-container *ngIf="state=='EDIT'">
    <div class="secondary-toolbar-item"><mat-icon svgIcon="cw:action_next"></mat-icon>{{selectedScanConfiguration.name}}</div>
  </ng-container>
</mat-toolbar>

<section class="main-content">
  <cw-ci-scan-configuration-list #scanConfigurationList *ngIf="state=='LIST'" (stateChange)="onStateChange($event)" ></cw-ci-scan-configuration-list>
  <cw-ci-scan-configuration-edit *ngIf="state=='EDIT' || state=='CREATE'" (stateChange)="onStateChange($event)" [scanConfiguration]="selectedScanConfiguration"></cw-ci-scan-configuration-edit>
</section>
